import styled from 'styled-components';

interface ContainerProps {
  gridColumn?: number;
  border?: boolean;
  focused?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-radius: 6px;
  grid-column: ${({gridColumn}) => `span ${gridColumn ?? 12}`};
`;

export const Label = styled.label`
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
`;

export const Input = styled.input`
  border: none;
  outline: none;
  color: ${(props) => props.theme.colors.text};
  font-weight: 600;
  background-color: transparent;
  padding: 10px;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  border-radius: 4px;

  &::placeholder {
    color: #adb5bd;
  }
`;
